import { type CSSProperties, forwardRef } from "react"

import { cn } from "@/shared/utils"

type BrandLogoProps = {
  className?: string
  style?: CSSProperties
  size?: "sm" | "md" | "lg"
}

const ARIA_LABEL = "MesaOTC"
const LOGO_LIGHT = "/brand/logo-mesaotc-light.webp"
const LOGO_DARK = "/brand/logo-mesaotc-dark.webp"

const SIZE_HEIGHT: Record<NonNullable<BrandLogoProps["size"]>, string> = {
  sm: "h-8",
  md: "h-10 md:h-11",
  lg: "h-12 md:h-14",
}

export const BrandLogo = forwardRef<HTMLSpanElement, BrandLogoProps>(
  function BrandLogo({ className, style, size = "md" }, ref) {
    return (
      <span
        ref={ref}
        className={cn("relative inline-flex items-center", className)}
        style={style}
        aria-label={ARIA_LABEL}
        role="img"
      >
        <img
          src={LOGO_LIGHT}
          alt={ARIA_LABEL}
          width={800}
          height={364}
          className={cn("w-auto dark:hidden", SIZE_HEIGHT[size])}
          loading="eager"
          decoding="sync"
          draggable={false}
        />
        <img
          src={LOGO_DARK}
          alt=""
          aria-hidden="true"
          width={800}
          height={427}
          className={cn("hidden w-auto dark:block", SIZE_HEIGHT[size])}
          loading="eager"
          decoding="sync"
          draggable={false}
        />
      </span>
    )
  },
)
